// extracted by mini-css-extract-plugin
export default {"competencyTest":"CompetencyTestForm_competencyTest__EAkkV","piMobile":"CompetencyTestForm_piMobile__8ygKY"};